module.exports = __webpack_public_path__ + "Firefox-da7fa028e28dab3844ba68956a32f011.png";


//////////////////
// WEBPACK FOOTER
// ./assets/browser-icons/Firefox.png
// module id = 1130
// module chunks = 0 1